import React from 'react';
import { Helmet } from 'react-helmet-async';
import AboutUs from './AboutUs';

const AboutUs_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>About Tang Wu Biotech</title>
      <meta
        name="description"
        content="Tang Wu Biotech provides safe, innovative food ingredient manufacturing and global catering solutions with premium certifications."
      />
      <meta name="keywords" content="Tang Wu, about, food safety, catering solutions" />
    </Helmet>
    <AboutUs />
  </div>
);

export default AboutUs_en;
